
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.2 12.1c.294 0 .527-.13.69-.382l6.46-10.172c.124-.198.178-.349.178-.506 0-.376-.253-.622-.629-.622-.266 0-.423.089-.587.349l-6.14 9.782-3.185-4.17c-.17-.24-.335-.335-.588-.335-.382 0-.656.267-.656.643 0 .157.069.334.198.499l3.548 4.518c.212.267.417.397.711.397z","fill":"#AAB4C0"}})])
          )
        }
      }
    